var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormWrapper",
    [
      _c(
        "FormControl",
        [
          _c("FormLabel", [
            _vm._v(_vm._s(_vm.$t("watchmen.channels.type.label"))),
          ]),
          _vm._v(" "),
          _c(
            "FormElement",
            { staticClass: "position-relative w-100" },
            [
              _c(
                "UiSelect",
                {
                  staticClass: "select-type",
                  attrs: {
                    disabled:
                      !_vm.isNewChannel &&
                      _vm.channel.type === _vm.CHANNEL_TYPE.EMAIL,
                  },
                  model: {
                    value: _vm.channel.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.channel, "type", $$v)
                    },
                    expression: "channel.type",
                  },
                },
                [
                  _c("option", { attrs: { value: "", disabled: "" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("watchmen.channels.type.select_placeholder")
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "option",
                    { domProps: { value: _vm.CHANNEL_TYPE.MOBILE } },
                    [_vm._v(_vm._s(_vm.$t("watchmen.channels.type.mobile")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    { domProps: { value: _vm.CHANNEL_TYPE.PHONE } },
                    [_vm._v(_vm._s(_vm.$t("watchmen.channels.type.phone")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    {
                      attrs: {
                        disabled:
                          !_vm.isNewChannel &&
                          _vm.channel.type !== _vm.CHANNEL_TYPE.EMAIL,
                      },
                      domProps: { value: _vm.CHANNEL_TYPE.EMAIL },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("watchmen.channels.type.email")) +
                          "\n        "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("ChannelIcon", {
                staticClass: "select-type-icon",
                attrs: { type: _vm.channel.type },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.channel.type === _vm.CHANNEL_TYPE.EMAIL
        ? _c(
            "FormControl",
            [
              _c("FormLabel", [
                _vm._v(_vm._s(_vm.$t("watchmen.channels.value_email"))),
              ]),
              _vm._v(" "),
              _c("InputEmail", {
                attrs: { placeholder: "example@domain.com" },
                model: {
                  value: _vm.channel.value_email,
                  callback: function ($$v) {
                    _vm.$set(_vm.channel, "value_email", $$v)
                  },
                  expression: "channel.value_email",
                },
              }),
            ],
            1
          )
        : _c(
            "FormControl",
            [
              _c("FormLabel", [
                _vm._v(_vm._s(_vm.$t("watchmen.channels.value_number"))),
              ]),
              _vm._v(" "),
              _c("InputPhone", {
                model: {
                  value: _vm.channel.value_number,
                  callback: function ($$v) {
                    _vm.$set(_vm.channel, "value_number", $$v)
                  },
                  expression: "channel.value_number",
                },
              }),
            ],
            1
          ),
      _vm._v(" "),
      _vm.showValidation && _vm.channel.type !== _vm.CHANNEL_TYPE.EMAIL
        ? _c(
            "FormControl",
            [
              _c("FormLabel", [
                _vm._v(_vm._s(_vm.$t("watchmen.channels.validation"))),
              ]),
              _vm._v(" "),
              _c(
                "FormElement",
                [_c("ChannelValidation", { attrs: { channel: _vm.channel } })],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }